const url = require('url');

const defaultState = [{ label: 'home', redirect: '/' }];
const steps = (state = defaultState, action) => {
  switch (action.type) {
    case 'ADD_STEP': {
      const label = action.step.label === 'boxes' ? 'Edge Device' : action.step.label;
      if (action.step.type && action.step.type === 'company' && state.length > 2) {
        state.pop();
        const item = state.concat({ label, redirect: action.step.redirect });
        localStorage.setItem('steps', JSON.stringify(item));
        return item;
      }
      const item = { label, redirect: action.step.redirect };
      localStorage.setItem('steps', JSON.stringify(state.concat(item)));
      return state.concat(item);
    }
    case 'POP_STEP': {
      return state.filter((_, i) => i !== state.length - 1);
    }
    case 'CLEAR_STEP': {
      let index = state.length;
      if (action.step) {
        state.find((item, i) => {
          if (item.label === action.step) {
            index = i;
            return i;
          }
        });
        state.length = index;
        return state;
      }
      return defaultState;
    }
    default:
      return state;
  }
};
export default steps;
